export default "__VITE_ASSET__Bj74_BpR__"